import { useEffect, useState } from 'react';
import { createAdminApiRequest } from '../pages/admin/api';
import useAdminToolsData from './useAdminToolsData';
import useAdminUsers from './useAdminUsers';
import useAdminGroups from './useAdminGroups';
import useAdminPermissions from './useAdminPermissions';
import useAdminAnnouncements from './useAdminAnnouncements';
import useAdminSecurity from './useAdminSecurity';
import useAdminTracks from './useAdminTracks';
import useAdminMembers from './useAdminMembers';
import useAdminMapSettings from './useAdminMapSettings';
import useAdminSystemSettings from './useAdminSystemSettings';

/**
 * 管理后台业务状态编排（登录会话见 useAdminPanelAuth）
 * 各域逻辑拆至 useAdmin* 子 hooks，返回 shape 与拆分前一致。
 */
export default function useAdminPanelData({ token, handleLogout, authed }) {
  const [tab, setTab] = useState('members');
  const apiRequest = createAdminApiRequest(token, () => handleLogout());

  const tools = useAdminToolsData({ apiRequest });
  const users = useAdminUsers({ apiRequest });
  const groups = useAdminGroups({ apiRequest });
  const permissions = useAdminPermissions({
    apiRequest,
    groups: groups.groups,
    fetchUsers: users.fetchUsers,
    fetchGroups: groups.fetchGroups
  });
  const announcements = useAdminAnnouncements({ apiRequest });
  const security = useAdminSecurity({ apiRequest });
  const tracks = useAdminTracks({ apiRequest });
  const members = useAdminMembers({ apiRequest, token, handleLogout });
  const mapSettings = useAdminMapSettings({
    apiRequest,
    fetchMembers: members.fetchMembers,
    memberPagination: members.memberPagination
  });
  const system = useAdminSystemSettings({ apiRequest });

  useEffect(() => {
    if (authed) {
      console.log('开始加载管理后台数据...');
      tools.fetchTools();
      users.fetchUsers();
      groups.fetchGroups();
      permissions.fetchPermissions();
      announcements.fetchAnnouncements();
      security.fetchPwd();
      members.fetchMembers();
      members.fetchOrganizations();
      mapSettings.fetchMapSettings();
      system.fetchSystemSettings();
      tracks.loadTrackSettings();
      tracks.loadTrackStats();
      tracks.loadTrackSessions();
      permissions.fetchAuditLogs();
    }
  }, [authed]);

  useEffect(() => {
    console.log('AdminPanel: 立即初始化系统设置...');
    setTimeout(() => {
      system.fetchSystemSettings();
    }, 100);
  }, []);

  return {
    tab, setTab,
    ...tools,
    ...users,
    ...groups,
    ...permissions,
    ...announcements,
    ...security,
    ...tracks,
    ...members,
    ...mapSettings,
    ...system,
    apiRequest
  };
}
